import { useMemo, useState } from 'react';
import { QDataTable } from '@kw/quokka-ui';
import { useFetchService } from '../../utils/fetchService';
import { useLocalStorage } from '../../utils/useLocalStorage';
import { OrganizationDropdown } from './OrganizationDropdown';
import { formatDateTime } from './utils';
import { MdmIntegrationStatus, statusText } from '../shared/mdmIntegrationStatus';
import { MdmIntegrationStatusControl } from '../shared/MdmIntegrationStatusControl';

const renderDate = (value: string | null | undefined) => (value ? formatDateTime(value) : 'N/A');

export const MdmIntegrations = () => {
  const [accessToken = ''] = useLocalStorage('accessToken', '');
  const [selectedOrganization, setSelectedOrganization] = useState('');

  const basePath = `/organizations/customer-support/${selectedOrganization}/mdm-integrations`;
  const { data, mutate } = useFetchService<MdmIntegrationStatus[]>(basePath, accessToken, Boolean(selectedOrganization));
  const rows: MdmIntegrationStatus[] = selectedOrganization ? data ?? [] : [];

  const columns = useMemo(
    () => [
      { field: 'name', headerName: 'Integration' },
      {
        field: 'status',
        headerName: 'Status',
        renderCell: (row: MdmIntegrationStatus) => statusText(row),
      },
      {
        field: 'statusChangedAt',
        headerName: 'Changed At',
        renderCell: (row: MdmIntegrationStatus) => renderDate(row.statusChangedAt),
      },
      { field: 'lastSync', headerName: 'Last Sync', renderCell: (row: MdmIntegrationStatus) => renderDate(row.lastSync) },
      {
        field: 'actions',
        headerName: '',
        renderCell: (row: MdmIntegrationStatus) => (
          <MdmIntegrationStatusControl
            label={row.name ?? `Integration ${row.mdmIntegrationId}`}
            status={row}
            basePath={`${basePath}/${row.mdmIntegrationId}`}
            onChange={mutate}
          />
        ),
      },
    ],
    [basePath, mutate],
  );

  return (
    <>
      <OrganizationDropdown setSelectedOrganization={setSelectedOrganization} />

      <QDataTable
        emptyTableText={selectedOrganization ? 'No MDM integrations configured' : 'Select an organization'}
        columns={columns}
        data={rows}
      />
    </>
  );
};
